import { render, staticRenderFns } from "./base-slide-title.vue?vue&type=template&id=0ffcb8f0&"
import script from "./base-slide-title.vue?vue&type=script&lang=js&"
export * from "./base-slide-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffcb8f0')) {
      api.createRecord('0ffcb8f0', component.options)
    } else {
      api.reload('0ffcb8f0', component.options)
    }
    module.hot.accept("./base-slide-title.vue?vue&type=template&id=0ffcb8f0&", function () {
      api.rerender('0ffcb8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/base-slide-title.vue"
export default component.exports